import { styled } from '@linaria/react';

const OrderForm = styled.form`
  width: 100%;
  max-width: 356px;
  line-height: normal;
  font-size: 16px;
  margin: 0 auto;
`;

const OrderFields = styled.div<{ submitting: boolean }>`
  position: relative;
  opacity: ${({ submitting }) => (submitting ? '0.5' : '1')};
`;

const InfoBadge = styled.div`
  background: #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  gap: 8px;
  padding: 8px;
  color: #424242;
  font-size: 14px;
  line-height: 20px;
`;

const AlreadyHaveAccount = styled.div`
  display: flex;
  justify-content: center;
  gap: 4px;
  color: #424242;
  font-size: 14px;
  line-height: 24px;
  margin-top: 16px;
`;

const LoginButton = styled.button`
  background: none;
  border: none;
  color: var(--bb-link-color);
  cursor: pointer;
  font-size: 14px;
  padding: 0;
  line-height: 24px;
  font-weight: 600;

  &:hover {
    color: var(--bb-link-color--hover);
  }
`;

const SignedInBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  background: #f1f5f9;
  border-radius: 3px;
  color: #424242;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 16px;
`;

export default {
  OrderForm,
  OrderFields,
  InfoBadge,
  AlreadyHaveAccount,
  LoginButton,
  SignedInBadge,
};
